import React, { Component } from "react";
import { Modal } from "react-bootstrap";
// import DateBlock from "../../../neetjee_guru/components/home/DateBlock";
import { Form, Row, Button, Col, Spinner } from "react-bootstrap";
import moment from "moment";
import "./_timeTableCreationModal.scss";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { components } from 'react-select'
import MultiSelect from "react-multi-select-component";
import { withApollo } from "react-apollo";


const ADD_LECTURER_PERIODS = gql`
mutation($params:AddLecturePeriods) {
    addLecturePeriods(params: $params)
}
`;


const FETCH_PERIODTIMINGS = gql`
 query($institute_id:Int,$branch_id:Int,$exam_id:Int){
  getClassPeriodsTimings(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id){
      period_id
      period_name
      period_time
    }
 }
 `;




class TimeTableCreationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date().toISOString().slice(0, 10),
            Update: [],
            Branch: "",
            branchError: "",
            Exam: "",
            examError: "",
            Section: "",
            sectionError: "",
            Class: "",
            classError: "",
            startdate: "",
            startTime: new Date(),
            lecturerPeriods: "",
            loader: 0,
            dateTimings: "",
            submitError: "",
            dataClear: 0,
            submitted: false,
            subjectValue: [],
            periodsList: [],
            multiSelectPeriodsList: [],
            periods: "",
            currentDate: new Date().toISOString().slice(0, 10),
            dataClear: 1,
            getEmployees: [],
            examName: "",
            getExams: [],
            getClasses: [],
            getSections: [],
            existingData: [],
            existingSelection: ""

        };
    }



    handleMultipleSelectInputChange = async (e, name) => {
        let seletedClasses = e
        console.log("eeee", e);
        // const delay = (ms) => new Promise((r) => setTimeout(r, ms));
        // await delay(200);
        if (name == "Periods") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    console.log("qbtopicval", qbtopicval)
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    subjectValue: qbsearchtopicvalue,
                    qbsearchsubject: qbsearchtopic,
                });
            }
        }
        let periodsArray = [];
        if (e.length > 0) {
            this.state.Update.map((item) => {

                let selectedOrUnselectedItems = e.filter((item1) => item1.value == item.id);
                console.log("inside", selectedOrUnselectedItems);

                if (selectedOrUnselectedItems.length > 0) {
                    periodsArray.push({ ...item, enabled: false, class_day_type_id: "2", periodTopic: "", sub_class_day_type_id: "2" })
                } else {
                    periodsArray.push({ ...item, enabled: true, class_day_type_id: "3", periodTopic: "", sub_class_day_type_id: "1" })
                }
            })
        } else {
            this.state.Update.map((item) => {
                periodsArray.push({ ...item, enabled: true, class_day_type_id: "3", periodTopic: "" })
            })
        }
        this.setState({ Update: periodsArray });
    }



    //  First Row 
    // ================
    handleInputChange = (e, i) => {
        const name = e.target.name;
        const value = e.target.value;
        console.log("nammamm", name, value);

        let getArray = [];

        if (name == "Branch") {

            if (value != "0") {
                console.log("value", value);

                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    Branch: value, branchError: "", Exam: "", Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getExams: getArray, getClasses: [], getSections: [], classError: "", examError: "", sectionError: "", existingData: []
                })

            } else {
                this.setState({
                    Branch: "", branchError: "", Exam: "", Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getExams: [], getClasses: [], getSections: [], classError: "", examError: "", sectionError: "", existingData: []
                })
            }
        }
        if (name == "Class") {
            if (value != "0") {

                let uniqueSections = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.Branch && item.exam_id == this.state.Exam && item.class_id == value).map((item1) => item1.section_id))].sort();

                uniqueSections.map((val) => {
                    let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualSectionData.id,
                        label: individualSectionData.section_name
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branchError: "", Section: "", Class: value, dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getSections: getArray,
                    classError: "", examError: "", sectionError: "", existingData: []
                })

            } else {

                this.setState({
                    branchError: "", Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getSections: [],
                    classError: "", examError: "", sectionError: "", existingData: []
                })

            }

            this.getEmployess();
        }
        if (name == "Exam") {
            if (value != "0") {


                let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.Branch && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branchError: "", Exam: value, Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getClasses: getArray, getSections: [],
                    classError: "", examError: "", sectionError: "", existingData: []
                })
            } else {
                this.setState({
                    branchError: "", Exam: "", Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [], multiSelectPeriodsList: [], getClasses: [], getSections: [], classError: "", examError: "", sectionError: "", existingData: []
                })

            }


        }
        if (name == "Section") {
            let array = [];
            this.setState({ Update: array, Section: value, sectionError: "", dateTimings: "" })
            this.getExistingTimeTable(value);
        }

        if (name == "dateTimings") {
            let periodsArray = [];


            console.log("hello", e.target.value, this.state.existingSelection);

            if (e.target.value == this.state.existingSelection) {

                this.state.existingData.map((item) => {

                    let sub_class_day_type_id = e.target.value;

                    if (e.target.value == "3") {
                        sub_class_day_type_id = "1"
                    }
                    periodsArray.push({ ...item, class_day_type_id: e.target.value, sub_class_day_type_id })
                });
            } else {

                if (e.target.value == 4 || e.target.value == 2) {
                    periodsArray.push({ id: "", periodDate: this.state.date, periodTime: "", periodSubjectId: "", period_name: "", periodLecturerId: "", periodTopic: "", subjectError: "", LecturerError: "", topicError: "", enabled: true, class_day_type_id: e.target.value, sub_class_day_type_id: e.target.value, existingData: [] })
                } else {
                    this.state.periodsList.map((item, index) => (
                        periodsArray.push({ id: item.period_id, periodDate: this.state.date, periodTime: item.period_time, periodSubjectId: "", period_name: item.period_name, periodLecturerId: "", periodTopic: "", subjectError: "", LecturerError: "", topicError: "", enabled: true, class_day_type_id: "", sub_class_day_type_id: "", existingData: [] })
                    ))
                }
            }

            this.setState({
                dateTimings: e.target.value, dateTimeError: "", Update: periodsArray
            });
        }

        if (name == "examName" || name == "holidayName") {

            let array = [];
            this.state.Update.map((item) => {
                array.push({ ...item, periodTopic: value })
            })
            this.setState({ Update: array, nameError: "" })
        }
    }

    selDate = (e) => {
        this.setState({ date: e.target.value, Branch: "", Exam: "", Section: "", Class: "", dateTimings: "", Update: [], getEmployees: [], periodsList: [] })
    }

    // ARRAY OF OBJECT 2ND ROW COLUMN
    // =================================


    handleChange = (a, i) => {

        let name = a.target.name;
        let value = a.target.value;

        console.log("name", name);



        let array = [];

        this.state.Update.map((item, index) => {
            if (i == index) {
                let periodSubjectId = item.periodSubjectId;
                let periodLecturerId = item.periodLecturerId;
                let periodTopic = item.periodTopic;
                let periodTime = item.periodTime;

                if (name == "Subject") {
                    periodSubjectId = value;
                    periodLecturerId = "";

                } else if (name == "Lecturer") {
                    periodLecturerId = value;
                }
                else if (name == "periodTime") {
                    periodTime = value;
                }
                else {
                    periodTopic = value;
                }

                array.push({ ...item, periodTopic, periodTime, periodLecturerId, periodSubjectId })
            } else {
                array.push({ ...item })
            }
        })


        this.setState({ Update: array })



        // this.setState(preState => {
        //     let array = [];
        //     preState.Update.map((item, index) => {
        //         if (i == index) {
        //             let periodSubjectId = item.periodSubjectId;
        //             let periodLecturerId = item.periodLecturerId;
        //             let periodTopic = item.periodTopic;
        //             let periodTime = item.periodTime;


        //             if (name == "Subject") {
        //                 periodSubjectId = value;
        //                 periodLecturerId = "";

        //             } else if (name == "Lecturer") {
        //                 periodLecturerId = value;
        //             }
        //             else if (name == "periodTime") {
        //                 periodTime = value;
        //             }
        //             else {
        //                 periodTopic = value;
        //             }

        //             console.log("else1", periodTopic);
        //             array.push({ ...item, periodTime, periodTopic, periodSubjectId, periodLecturerId, subjectError: "", LecturerError: "", topicError: "", })
        //         } else {

        //             let periodTopic = item.periodTopic;
        //             if (!item.enabled) {
        //                 periodTopic = examName
        //             }
        //             array.push({ ...item, periodTopic })
        //         }
        //     })
        //     console.log("www", array);
        //     this.setState({ Update: array })
        //     console.log("eee", array);
        // })
    }



    handleSubmit = (e) => {
        e.preventDefault();

        if (this.state.dateTimings == "2" || this.state.dateTimings == "4") {
            if (this.state.Update[0].periodTopic == "") {
                this.setState({ nameError: "Enter Valid Name" })
                return ""
            }
        }

        let array = [];
        if (this.state.Update.length > 0) {
            this.state.Update.map((item) => {
                let class_topic = item.periodTopic;
                array.push({
                    class_period_id: parseInt((item.id)),
                    subject_id: parseInt((item.periodSubjectId)),
                    employee_id: parseInt((item.periodLecturerId)),
                    class_topic: (class_topic).toString(),
                    class_date: moment(this.state.date, 'YYYY-MM-DD').unix().toString(),
                    class_day_type_id: parseInt(this.state.dateTimings),
                    sub_class_day_type_id: parseInt(item.sub_class_day_type_id)

                })

            })
        }
        let params = {
            class_id: parseInt(this.state.Class),
            exam_id: parseInt(this.state.Exam),
            branch_id: parseInt(this.state.Branch),
            institute_id: parseInt(Cookies.get("institutionid")),
            section_id: parseInt(this.state.Section),
            period_timings: array,
        };
        console.log("params", params, this.state.Update);



        this.addLecturerPeriods1(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                periodError: error.graphQLErrors.map(x => x.message), loader: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });

        this.setState({
            loader: 1
        });

    }

    addLecturerPeriods1 = async (
        params) => {
        await this.props.addLecturerPeriods({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addLecturePeriods) {

                    this.setState({
                        loader: 0,
                        submitted: true
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }

        });
    };

    // Delete HandleSubmit
    // ====================
    deleteHandle = (id) => {
        let deleterows = this.state.Update.filter((item, index) => item.id != id)
        console.log("hhh", deleterows, id);
        this.setState({
            Update: deleterows,
        })
    }

    // Button Click Enter Some , Click Wrong Button Again Ask Starting
    // ===============================================================
    componentDidUpdate() {
        if (this.props.show == true && this.state.dataClear == 0) {
            this.setState({
                date: new Date().toISOString().slice(0, 10),
                Update: [],
                Branch: "",
                branchError: "",
                Exam: "",
                examError: "",
                Section: "",
                sectionError: "",
                Class: "",
                classError: "",
                startdate: "",
                startTime: new Date(),
                lecturerPeriods: "",
                loader: 0,
                dateTimings: "",
                submitError: "",
                dataClear: 1,
                submitted: false,
                subjectValue: [],
                periodsList: [],
                multiSelectPeriodsList: [],
                periods: "",
                currentDate: new Date().toISOString().slice(0, 10),
                dataClear: 1,
                getEmployees: [],
                examName: "",
                getExams: [],
                getClasses: [],
                getSections: [],
                existingData: []

            })
        }
        if (this.props.show == false && this.state.dataClear == 1) {
            this.setState({
                dataClear: 0
            })
        }
    }


    getEmployess = async () => {

        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,){
                getEmployees(institute_id:$institute_id,branch_id:$branch_id){
                  employee_id
                  employee_name
                  subject_ids
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.Branch)
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getEmployees.length > 0) {
            this.setState({ getEmployees: result.data.getEmployees })

        } else {
            this.setState({ getEmployees: [] })
        }

        const periods = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int){
                getClassPeriodsTimings(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id){
                    period_id
                    period_name
                    period_time
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.Branch),
                exam_id: parseInt(this.state.Exam)
            },
            fetchPolicy: 'network-only'
        })

        if (periods.data.getClassPeriodsTimings.length > 0) {

            let multiSelectPeriodsList = [];

            periods.data.getClassPeriodsTimings.map((item) => {
                multiSelectPeriodsList.push({ value: item.period_id, label: item.period_name })
            })

            this.setState({ periodsList: periods.data.getClassPeriodsTimings, multiSelectPeriodsList })

        } else {
            this.setState({ periodsList: [], multiSelectPeriodsList: [] })
        }
    };

    getExistingTimeTable = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int,$section_id:Int,$class_start_date:String,$class_id:Int){
                getClassTimeTable(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,section_id:$section_id,class_start_date:$class_start_date,class_id:$class_id){
                    class_day_type_id
                    class_period_id
                    period_name
                    subject_id
                    subject_name
                    employee_id
                    employee_name
                    class_topic
                    sub_class_day_type_id
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.Branch),
                class_id: parseInt(this.state.Class),
                section_id: parseInt(val),
                exam_id: parseInt(this.state.Exam),
                class_start_date: moment(this.state.date, 'YYYY-MM-DD').unix().toString()
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getClassTimeTable.length > 0) {
            let data = result.data.getClassTimeTable;
            let array = [];
            let selectedPeriodList = [];
            let examName = "";
            data.map((item) => {
                let enabled = true;
                if (item.class_day_type_id == "3" && item.sub_class_day_type_id == "2") {
                    enabled = false
                    examName = item.class_topic
                    selectedPeriodList.push({ label: item.period_name, value: item.class_period_id })
                }
                array.push({ class_day_type_id: item.class_day_type_id, sub_class_day_type_id: item.sub_class_day_type_id, enabled: enabled, id: item.class_period_id, period_name: item.period_name, periodTopic: item.class_topic, periodLecturerId: item.employee_id, periodSubjectId: item.subject_id, subjectError: "", LecturerError: "", topicError: "" })

            });

            this.setState({ dateTimings: data[0].class_day_type_id, Update: array, subjectValue: selectedPeriodList, examName, existingData: array, existingSelection: data[0].class_day_type_id })
        }

    };

    render() {

        console.log("state", this.state);

        const { dateTimings } = this.state;
        let periodsSelectAll = true;
        let periodslabelledby = "Select";
        let periodsdisablesearch = false;
        if (this.state.periodsList.length > 0) {
            periodsSelectAll = true;
            periodsdisablesearch = false;
        }
        else {
            periodsdisablesearch = true;
            periodsSelectAll = false;
            periodslabelledby = "Periods"
        }


        return (
            <Form>
                <div className="container-fluid  POPUP_PAGE">
                    <Modal
                        {...this.props}
                        size="lg"
                        aria-labelledby="contained-modal-title-venter"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-lg">Lecturer TimeTable </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-4" style={{ maxHeight: "600px", overflowX: "auto" }}
                        >
                            <div className="">
                                <div className="d-flex justify-content-end">
                                    {/* <div className="col-sm-8 h5 fw-bold " style={{ marginLeft: "-13px" }}>Update Time</div> */}
                                    {/* <div className="col-sm-4"> */}
                                    {/* =====Calunder===== */}
                                    <Row>
                                        <div className="filter-block d-flex align-items-center mr-4">
                                            <input type="date" className="date  form-control" value={this.state.date} onChange={this.selDate} style={{ borderRadius: "15px" }} />
                                        </div>
                                    </Row>
                                    {/* </div> */}
                                </div>
                            </div>
                            <Row>
                                <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                                    <Form>
                                        <Form.Row>
                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectClass">
                                                <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                                <Form.Control as="select" name="Branch" onChange={this.handleInputChange} value={this.state.Branch} isInvalid={this.state.branchError}>
                                                    <option value={this.state.defaultvalue}>--Select Branch--</option>
                                                    {this.props.globals.globalBranches.map(branchdata => (
                                                        <option key={branchdata.id} value={branchdata.id}>
                                                            {branchdata.branch_name}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.branchError}
                                                </Form.Text>
                                            </Form.Group>


                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="Selectexam">
                                                <Form.Label className="text-uppercase font-weight-bold">Exam</Form.Label>
                                                <Form.Control as="select" name="Exam" onChange={this.handleInputChange} value={this.state.Exam} isInvalid={this.state.examError}>
                                                    <option value={this.state.defaultvalue}>--Select Exam--</option>
                                                    {this.state.getExams.map(item => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.examError}
                                                </Form.Text>
                                            </Form.Group>


                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectClass">
                                                <Form.Label className="text-uppercase font-weight-bold">Class</Form.Label>
                                                <Form.Control as="select" name="Class" onChange={this.handleInputChange} value={this.state.Class} isInvalid={this.state.classError}>
                                                    <option value={this.state.defaultvalue}>--Select Class--</option>
                                                    {this.state.getClasses.map(classdata => (
                                                        <option key={classdata.value} value={classdata.value}>
                                                            {classdata.label}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.classError}
                                                </Form.Text>
                                            </Form.Group>

                                            <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectClass">
                                                <Form.Label className="text-uppercase font-weight-bold">Section</Form.Label>
                                                <Form.Control as="select" name="Section" onChange={this.handleInputChange} value={this.state.Section} isInvalid={this.state.sectionError}>
                                                    <option value={this.state.defaultvalue}>--Select Section--</option>
                                                    {this.state.getSections.map(sectiondata => (
                                                        <option key={sectiondata.value} value={sectiondata.value}>
                                                            {sectiondata.label}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text className="form-text text-danger" type="invalid">
                                                    {this.state.sectionError}
                                                </Form.Text>
                                            </Form.Group>
                                        </Form.Row>
                                    </Form>
                                </Col>
                            </Row>
                            <div className="row">
                                <div className="col-sm-4">
                                    {/* =====Class Periods===== */}
                                    {

                                        this.state.Section != "" && this.state.Section != "--Select Section--" ? (
                                            <>
                                                <h6 value="" >Select Choise</h6>
                                                <select style={{ height: "35px" }} className="mt-2 form-control col-sm-10" name="dateTimings" value={this.state.dateTimings} onChange={this.handleInputChange}>
                                                    <option value="">--Select Your Choise--</option>
                                                    <option value="1">Class</option>
                                                    <option value="2">Exam</option>
                                                    <option value="3">Class & Exam</option>
                                                    <option value="4">Holiday</option>
                                                </select>
                                                <div className="form-text text-danger">{this.state.dateTimeError}</div>
                                            </>
                                        )
                                            :
                                            ("")
                                    }

                                </div>

                                {/* =====Drop Down Periods===== */}
                                <div class="col-sm-4">

                                    {
                                        dateTimings == "3" ? (
                                            <>
                                                <h6 className="mt-1">Select periods for Exams </h6>
                                                <MultiSelect
                                                    className="mt-2"
                                                    overrideStrings={{
                                                        "allItemsAreSelected": "All Periods are selected.",
                                                        "selectSomeItems": periodslabelledby
                                                    }
                                                    }
                                                    disableSearch={periodsdisablesearch}
                                                    hasSelectAll={periodsSelectAll}
                                                    options={this.state.multiSelectPeriodsList}
                                                    value={this.state.subjectValue}
                                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "Periods")}
                                                    labelledBy={"Periods"}
                                                />
                                            </>
                                        ) : dateTimings == "2" ? (
                                            <>
                                                <h6 value="">Exam Name</h6>
                                                <div className="row">
                                                    <input type="text" className="col-sm-8 form-control" style={{ height: "33px" }} placeholder="Enter exam Name" name="examName" onChange={this.handleInputChange} value={this.state.Update[0]?.periodTopic} />
                                                </div>
                                                <div className="form-text text-danger">{this.state.nameError}</div>
                                            </>
                                        ) : dateTimings == "4" ? (
                                            <>
                                                <h6 value="">Holiday Name</h6>
                                                <div className="row">
                                                    <input type="text" className="col-sm-8 form-control" style={{ height: "33px" }} placeholder="Enter holiday Name" name="holidayName" onChange={this.handleInputChange} value={this.state.Update[0]?.periodTopic} />
                                                </div>
                                                <div className="form-text text-danger">{this.state.nameError}</div>
                                            </>
                                        ) : ("")
                                    }
                                </div>
                            </div>

                            {
                                this.state.Update.length > 0 ?
                                    (
                                        this.state.Update.map((val, i) => {
                                            console.log("valu", val);
                                            let lecturesData = [];
                                            let examWiseSubjects = [];

                                            if (val.periodSubjectId != null && val.periodSubjectId != "") {
                                                lecturesData = this.state.getEmployees.filter((employee) => employee.subject_ids == val.periodSubjectId)
                                            }

                                            if (this.props.globals.offlineExamSubjects.length > 0) {
                                                this.props.globals.exams.filter((item) => item.id == this.state.Exam)[0].exam_subjects.map((item1) => {
                                                    this.props.globals.offlineExamSubjects.map((item2) => {
                                                        if (item1.subject_id == item2.id) {
                                                            examWiseSubjects.push({ ...item2 })
                                                        }
                                                    })
                                                })
                                            }


                                            if (dateTimings == "1" || dateTimings == "3") {
                                                return (
                                                    <>
                                                        <Form>
                                                            <div className="row my-4">


                                                                <div className="col-sm-2">
                                                                    <h6>Period Time</h6>

                                                                    <div className="row">
                                                                        <input type="text" className="mt-2 col-sm-10 form-control m-2" style={{ height: "33px" }} value={val.period_name} disabled={true} />
                                                                    </div>
                                                                </div>

                                                                {
                                                                    val.enabled ?
                                                                        (
                                                                            <>
                                                                                <div className="col-sm-3">
                                                                                    <h6>Subject</h6>
                                                                                    <select className="mt-3 form-control col-sm-10" name="Subject" style={{ height: "33px" }} onChange={(e) => { this.handleChange(e, i) }}>
                                                                                        <option value="">--Subject--</option>
                                                                                        {
                                                                                            examWiseSubjects.map((item, index) => {
                                                                                                return (
                                                                                                    <option value={item.id} key={index} selected={val.periodSubjectId == item.id ? true : false}>{item.subject}</option>
                                                                                                )
                                                                                            })
                                                                                        };
                                                                                    </select>
                                                                                    <div className="form-text text-danger fw-bold">{val.subjectError}</div>
                                                                                </div>

                                                                                <div className="col-sm-3">
                                                                                    <h6>Lecturer</h6>
                                                                                    <select className="mt-3 form-control col-sm-10" style={{ height: "33px" }} onChange={(e) => { this.handleChange(e, i) }} name="Lecturer" >
                                                                                        <option value="">--Lecturer--</option>

                                                                                        {
                                                                                            lecturesData.map((item, index) => {
                                                                                                return (

                                                                                                    <option value={item.employee_id} key={index} selected={val.periodLecturerId == item.employee_id ? true : false} >{item.employee_name}</option>
                                                                                                )
                                                                                            })
                                                                                        }

                                                                                    </select>
                                                                                    <div className="form-text text-danger fw-bold">{val.LecturerError}</div>
                                                                                </div>
                                                                                <div className="col-sm-3">
                                                                                    <h6>Topic</h6>
                                                                                    <div className="row">
                                                                                        <input type="text" className="mt-2 col-sm-8 form-control m-2" style={{ height: "33px" }} placeholder="Enter Topic" name="Topic" value={val.periodTopic} onChange={(e) => { this.handleChange(e, i) }} disabled={val.enabled == true ? false : true} />
                                                                                    </div>
                                                                                    <div className="form-text text-danger fw-bold">{val.topicError}</div>
                                                                                </div>

                                                                            </>
                                                                        )
                                                                        :
                                                                        (
                                                                            <>
                                                                                <div className="col-sm-3">
                                                                                    <h6>Exam Name</h6>
                                                                                    <div className="row">
                                                                                        <input type="text" className="mt-2 col-sm-8 form-control m-2" style={{ height: "33px" }} placeholder="Enter exam Name" name="examName" value={val.periodTopic} onChange={(e) => { this.handleChange(e, i) }} />
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                }

                                                            </div>
                                                        </Form>
                                                    </>
                                                )
                                            }
                                        }
                                        )
                                    )
                                    :
                                    ("")
                            }
                            {/* ===== HANDLE SUBMIT ERROR &  CLICK BUTTON ===== */}
                            <div className="d-flex justify-content-end">
                                <Row>
                                    <Col sm={12}>
                                        {
                                            this.state.Update.length > 0 && this.state.dateTimings != "" ?
                                                (
                                                    this.state.loader == 0 ? (
                                                        <Button className="btn btn-success text-uppercase submit_btn" style={{ width: "171px" }} onClick={this.handleSubmit} type="submit" inline>Create TimeTable</Button>
                                                    ) : (
                                                        <Button className="btn btn-success submit_btn" type="submit" inline disabled>
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                            Creating...
                                                        </Button>
                                                    )
                                                )
                                                :
                                                ("")
                                        }
                                    </Col>
                                </Row>
                            </div>
                            {
                                this.state.submitted == true ? (
                                    <p className="text-success d-flex justify-content-end mt-1">TimeTable Create Successfully</p>
                                ) : ("")
                            }
                        </Modal.Body>
                    </Modal>
                </div>
            </Form>
        )
    }
}

export default withRouter(withApollo(compose(
    graphql(ADD_LECTURER_PERIODS, {
        name: "addLecturerPeriods"
    }),
)(TimeTableCreationModal))
);